/**
 * Closing-totals footer that sits beneath the entries table. Three-cell
 * grid: total credits, total debits, closing balance. For liability
 * accounts (credit card, mortgage, loan) the labels semantically flip —
 * "money in" becomes the new charge column ("debits") while "money out"
 * (a payment toward the debt) is the credit column. The shell decides
 * which way to swap and just passes the values.
 */
import React from 'react';
import { fmtMoney } from '../../lib/format';

const TotalsFooter = ({ isLiability, money_in, money_out, closing_balance }) => (
  <div className="px-6 sm:px-10 py-5 border-t border-[#E2E8F0] bg-[#F8FAFC]">
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#64748B]">Total credits</div>
        <div className="text-lg font-semibold text-[#10B981] mt-1" data-testid="total-credits">£{fmtMoney(isLiability ? money_out : money_in)}</div>
      </div>
      <div>
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#64748B]">Total debits</div>
        <div className="text-lg font-semibold text-[#EF4444] mt-1" data-testid="total-debits">£{fmtMoney(isLiability ? money_in : money_out)}</div>
      </div>
      <div className="sm:text-right">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#64748B]">Closing balance</div>
        <div className={`text-xl font-bold mt-1 ${closing_balance < 0 ? 'text-[#EF4444]' : 'text-[#020617]'}`} data-testid="closing-balance">£{fmtMoney(closing_balance)}</div>
      </div>
    </div>
  </div>
);

export default TotalsFooter;
